export default __webpack_public_path__ + "static/media/activePop.9d44b77b.svg";